export default {
  title: '选择{type}',
  uploadImage: '上传图片',
  uploadVideo: '上传视频',
  selectImage: '选择图片',
  selectVideo: '选择视频',
  maxCountTip: '最多只能选择 {count} 个素材',
};
